import React from 'react';
import FairstoneStylesProvider from '@fairstone/ui/core/providers/FairstoneStylesProvider';

const theme: React.FC = ({ children }) => <FairstoneStylesProvider>{children}</FairstoneStylesProvider>;

export default theme;
